/**
 * Translate description: Table component
 */

import { Fragment, useContext } from 'react';

import { useLanguageContext } from "../../../context/LanguageContext";
import AppContext from '../../../context/AppContext';

import Filter from '../../../components/filter/Filter';
import FilterSourceLang from '../../../components/filter/FilterSourceLang';
import FilterTranslated from '../../../components/filter/FilterTranslated';
import FilterStatus from '../../../components/filter/FilterStatus';
import FilterStore from '../../../components/filter/FilterStore';

import {
  ContentTable, ContentHeader, ContentHeaderItem, ContentBody,
  ContentBodyCheckbox, ContentBodyItem,
  ContentBodyItemImage, ContentBodyItemStatus, ContentBodyItemStatusCPA,
  ContentBodyItemTranslations, ContentBodyItemEdit
} from '../../../components/blocks/ContentTable';

import { ContentList, ContentListRow, ContentListItem } from '../../../components/blocks/ContentList';

import moment from 'moment/moment';

export default function Content() {
  const { t } = useLanguageContext();
  const { listItems } = useContext(AppContext);
  const { loading } = useContext(AppContext);

  return (
    <Fragment>
      <Filter fields={['name']}>
        <FilterSourceLang />
        <FilterTranslated />
        <FilterStatus />
        <FilterStore />
      </Filter>

      <ContentTable>
        <ContentHeader>
          <ContentHeaderItem title={t('ID')} sortBy="id" width={50} />
          <ContentHeaderItem title={t('Image')} width={100} />
          <ContentHeaderItem title={t('Name')} sortBy="name" />
          <ContentHeaderItem title={t('Translations')} width={120} />
          <ContentHeaderItem title={t('Creator')} width={100} />
          <ContentHeaderItem title={t('Status')} width={100} />
          <ContentHeaderItem title={t('Status CPA')} width={100} />
          <ContentHeaderItem title={t('Updated at')} sortBy="updated_at" width={100} />
          <ContentHeaderItem width={100}></ContentHeaderItem>
        </ContentHeader>

        <ContentBody colspan={11}>
          {(Array.isArray(listItems) && !loading && listItems?.length) ? (
            listItems.map((row) => (
              <tr key={row.id}>
                <ContentBodyCheckbox row={row} />
                <ContentBodyItem>{row.id}</ContentBodyItem>
                <ContentBodyItemImage image={row.logo} />
                <ContentBodyItem to={`/offer/${row.id}`}>{row.name}</ContentBodyItem>
                <ContentBodyItemTranslations row={row} editLink="offer" />
                <ContentBodyItem>{row.creator?.name ?? row.creator?.login ?? ''}</ContentBodyItem>
                <ContentBodyItemStatus row={row} />
                <ContentBodyItemStatusCPA row={row} />
                <ContentBodyItem>{moment(row.updated_at).format('YYYY-MM-DD HH:mm:ss')}</ContentBodyItem>
                <ContentBodyItemEdit row={row} addLink='offers' editLink='offer' deleteLink='offers' />
              </tr>
            ))
          ) : null}
        </ContentBody>
      </ContentTable>

      <ContentList>
        {(Array.isArray(listItems) && !loading && listItems?.length) ? (
          listItems.map((row) => (
            <ContentListRow key={row.id} row={row} editLink={'offer'} deleteLink={'offers'}>
              <ContentListItem>{row.name}</ContentListItem>
              <ContentListItem>{row.slug}</ContentListItem>
            </ContentListRow>
          ))
        ) : null}
      </ContentList>

    </Fragment >
  );
}